export default {
  helpCenter: {
    viewTitle: "Help Center",
    tabTitle: "HelpCenter",
    link: "リンク",
    manual: "利用マニュアル",
    help: "ヘルプ集",
    instruction: {
      question: "AutoStream基本操作について",
      answer: "詳細の操作方法に関しては、下記のリンクをご参照ください。",
    },
    attentionToSafari: {
      question: "AutoStreamをSafariで利用する方へ",
      answer:
        "推奨環境: 14.0以降 <br>「New Report」「Edit Report」「New Adunit Group」「Edit Adunit Group」にて、トラックパッド等を用いたジェスチャーでブラウザバックすると意図しない挙動が発生する可能性がございます。<br>ページ遷移する際はAutoStream内のリンクから遷移するようご了承ください。",
    },
    refreshedPrebid: {
      question: "Prebid実装の本番反映直後の管理画面への数値反映はいつになるのでしょうか？",
      answer:
        "管理画面の数値ですが本番環境への実装から7日後に正常稼働致します。<br>※メディア様毎/ Bidder毎に各社のデータを抽出し、コードを作成しているのでお時間を要してしまいます。<br>数値自体は3日後目処に表示されますが弊社での正常動作確認のお時間を頂戴しておりますので暫定値とご認識ください。",
    },
    refreshedBidder: {
      question: "Bidder追加直後の管理画面への数値反映はいつになるのでしょうか？",
      answer:
        "数値自体は3日後目処に表示されますが弊社での正常動作確認のお時間を頂戴しておりますので暫定値とご認識ください。",
    },
    delayRefreshedBidder: {
      question: "週明けの数値反映が遅いBidderはありますでしょうか？",
      answer:
        "FLUXの管理画面は各Bidderの管理画面から数値取得しております。Verizonは週明けの月曜日などに反映が遅れるケースが多く、それに伴って弊社側での取り組みにも時間がかかっている場合がございます。緊急を要する場合にはFLUX側にて手動でレポートを取得することも可能ですので弊社担当にお申し付けください。",
    },
    bidderNameSyntax: {
      question: "Bidderごとの枠別の命名規則はありますでしょうか？",
      answer:
        "各Bidderの命名規則は下記のスプレッドシートに記載させて頂いております。<br>貴社との業務連絡シート上の枠情報タブより、各BidderのIDもご参照ください。",
    },
    canUseApi: {
      question: "レポートAPIはありますでしょうか？",
      answer: "大変恐縮ではございますが、レポートAPIは提供しておりません。",
    },
    revenueGap: {
      question:
        "管理画面とFLUXアカウントにて発生した広告収益の確定値とのズレが発生するのはなぜでしょうか？",
      answer:
        "弊社管理画面は各Bidderの管理画面で表示されている日時のデータを取得しております。<br>各Bidder様の方で後日調整金額が入った場合、取得するようにはしていますが拾いきれない部分があります。そのため、各Bidderの管理画面上で表示されている速報値/ 暫定値としてご認識ください。<br>尚、FLUXアカウントにて発生した広告収益の確定値は毎月初に送付させて頂きます支払い通知書を正としてご確認頂けますようお願い致します。",
    },
    manyBidderDisadvantages: {
      question: "Bidder接続数増加による表示速度に与えるデメリットはあるのでしょうか？",
      answer:
        "PrebidでのBidder読み込みは並列処理を行っており、Bidderを追加する記述による遅延はほとんど生じません。<br>加えて、Timeoutでの設定を行っており、表示速度の調整は可能となっております。※Timeoutの設定はデフォルトで2000msとなっております。<br>こちらのPrebid処理時間を早めることも可能でございますので、ご調整を希望される場合はご相談ください。",
    },
    optimalBidderConnections: {
      question: "最適なBidderの接続数は何社でしょうか？",
      answer:
        "弊社では、可能な限り接続Bidderを増やすことを推奨しており、「Bidderの数を少なくすることによって得られるレイテンシー改善のメリット」＜「Bidderを追加する(しておく)ことによる収益性UPのメリット」と考えています。<br>Bidder追加をしても読み込み時間に大きな変化があまりなく、Bidderを減らすよりもTimeoutの調整などの施策を実施するほうが、効果があると想定しているため基本的には外すことは推奨しておりません。",
    },
    pubMaticSortingLogic: {
      question:
        "PubMatic経由の売り上げがOthersに振り分けられる場合がありますがどの様なロジックでOthersに振り分けられるのでしょうか？",
      answer:
        "PubMatic社の売り上げがOthersに振り分けられる条件は下記になります。<br>・1週間の売上が10ドル未満の“Advertiser”と“Advertiser Domain”のデータ<br>・1週間の売上が10ドル未満の“Site”のデータ<br>・1週間の売上が5ドル未満の“Ad Tag”のデータ<br>※詳しくはPubMatic社のヘルプをご確認ください。",
    },
  },
};
